<section class="report-overview">
  @if (summary) {
    <article class="card overview-card average-ticket">
      <h3 class="overview-card__title">Ticket Médio</h3>
      <div class="container">
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ summary.average_ticket | currency: "BRL" }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Vendido Hoje</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ salesProductionValue(summary.sold_today) | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.sold_today.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Vendido Ontem</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ salesProductionValue(summary.sold_yesterday) | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.sold_yesterday.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Vendido na Semana</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ salesProductionValue(summary.sold_this_week) | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.sold_this_week.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Vendido no Mês</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ salesProductionValue(summary.sold_this_month) | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.sold_this_month.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Reembolsados</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ summary.refunded.value | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.refunded.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Cortesias</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ summary.complimentary.value | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.complimentary.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Transferências</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ summary.transferred.value | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.transferred.quantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Cupom de Desconto</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ couponDiscountValue | currency: "BRL" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ couponDiscountQuantity }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">PDV Evento</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ (pdvSalesValue | currency: "BRL") ?? "—" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ pdvSalesQuantity ?? "—" }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Total de Vendas</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">
          {{
            (summary.valid_sales?.gross_value | currency: "BRL") ??
              (summary.valid_sales?.value | currency: "BRL") ??
              "R$ 0,00"
          }}
        </p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ summary.valid_sales?.quantity ?? 0 }}</p>
      </div>
    </article>

    <article class="card overview-card">
      <h3 class="overview-card__title">Vendedor</h3>
      <div>
        <p class="overview-card__content-title">Valor:</p>
        <p class="overview-card__content">{{ (sellerTotal?.value | currency: "BRL") ?? "R$ 0,00" }}</p>
      </div>
      <div>
        <p class="overview-card__content-title">Quantidade:</p>
        <p class="overview-card__content">{{ sellerTotal?.quantity ?? 0 }}</p>
      </div>
    </article>
  } @else {
    @for (_ of [].constructor(12); track $index) {
      <article class="card overview-card">
        <p-skeleton height="10rem" />
      </article>
    }
  }
</section>
